

const IndexMyPersonalAccessTokensItemSchema = {
  email: { format: 'email' },
  expiresAt: { format: 'date-time' },
  revokedAt: { format: 'date-time' },
  lastUsedAt: { format: 'date-time' },
  usageCount: { type: 'integer' },
  failedAttemptCount: { type: 'integer' },
  createdAt: { format: 'date-time' },
  updatedAt: { format: 'date-time' }
}

export default IndexMyPersonalAccessTokensItemSchema
